export default __webpack_public_path__ + "static/media/kitchen.91fba4ed.png";